import { styled } from "@mui/material";
import { editorName } from "../classes.js";
const Footer = styled("div", {
  name: editorName,
  slot: "Footer",
  overridesResolver: (_, styles) => styles.footer,
  shouldForwardProp: (prop) => !["enableFooterPadding", "ownerState"].includes(prop.toString())
})(({ theme, ownerState, enableFooterPadding }) => ({
  gap: theme.spacing(0.5),
  display: "flex",
  flexDirection: "column",
  ...enableFooterPadding && {
    padding: theme.spacing(2)
  },
  ...ownerState?.disabled && {
    backgroundColor: (theme.vars ?? theme).palette.grey[100]
  }
}));
export {
  Footer
};
//# sourceMappingURL=Footer.js.map
